import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import strings from '../../utils/strings';
import updateRequiredTestUserInfo from '../../api/updateRequiredTestUserInfo';


import {goToNextStep} from '../../actions/index';

class RequiredCandidateInfo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			gender: '',
			submitEnabled: true,
			error: '',
		};
	}

	onSubmit = (event) => {
		event.preventDefault();

		const {gender, submitEnabled} = this.state;
		const {onGoToNextStep} = this.props;

		if (!gender) {
			this.setState({error: strings.gender});
			return;
		}

		if (!submitEnabled) {
			return;
		}

		this.setState({
			submitEnabled: false,
			error: '',
		});

		updateRequiredTestUserInfo({
			gender,
		})
			.then(onGoToNextStep)
			.catch((err) => {
				console.log(err);

				this.setState({
					submitEnabled: true,
					error: 'Kunne ikke lagre informasjonen. Prøv igjen.',
				});
			});
	};

	render() {
		const {gender, error} = this.state;

		const genders = [
			{
				label: strings.female,
				value: 'f',
			},
			{
				label: strings.male,
				value: 'm',
			},
		];

		return (
			<div className="lit-test-intro">
				<h1 className="lit-page-title">{strings.welcomeToTest}</h1>

				<div className="lit-intro">
					<form className="pre-test-form required-candidate-info-form" onSubmit={this.onSubmit}>
						<div className="lit-input inline">
							<label className="lit-input__label wider">
								{strings.gender}
							</label>

							<div className="lit-input__field lit-radios">
								{genders.map((genderOption) => {
									const {label, value} = genderOption;

									return (
										<span
											className="lit-radio"
											key={value}
										>
											<input
												checked={value === gender}
												className="lit-radio__field"
												id={`gender${value}`}
												name="gender"
												onChange={() => {
													this.setState({
														gender: value,
														error: '',
													});
												}}
												required
												type="radio"
											/>

											<label
												className="lit-radio__label"
												htmlFor={`gender${value}`}
											>
												{label}
											</label>
										</span>
									);
								})}
							</div>
						</div>

						{error && (
							<div
								style={{
									color: 'red',
									marginBottom: '15px',
								}}
							>
								{error}
							</div>
						)}

						<button
	className="lit-btn lit-btn--huge bg-primary"
	type="submit"
	disabled={!gender || !this.state.submitEnabled}
>
	{strings.start}
</button>
					</form>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
};

export default connect(null, mapDispatchToProps)(RequiredCandidateInfo);